import { render, staticRenderFns } from "./EquipmentManagementExpand.vue?vue&type=template&id=4b4c5cd8&scoped=true&"
import script from "./EquipmentManagementExpand.vue?vue&type=script&lang=js&"
export * from "./EquipmentManagementExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c5cd8",
  null
  
)

export default component.exports